import Firebase from 'firebase/compat/app'
import ReactGA from 'react-ga'
import { prepareDocForUpdate } from './helpers/firestoreHelpers'

const updateScript = (scriptId, values) => {

  ReactGA.event({
    category: 'Script',
    action: 'Update script',
  })

  return Firebase.firestore()
    .collection('scripts')
    .doc(scriptId)
    .update(prepareDocForUpdate(values))
    .catch( error => {
      alert(`Whoops, couldn't edit the post: ${error.message}`)
    })
}

export default updateScript
